module.exports = __webpack_public_path__ + "static/media/comming_soon.b0cb823f.png";